import * as Yup from "yup";

export const formValidation = (formFields = []) => {
  const validationShape = {};
  formFields?.forEach(field => {
    let validator = Yup.string();
    if (field.validation?.required) {
      validator = validator.required(
        field?.message || `Please enter a valid ${field.label?.toLowerCase()}`
      );
    }
    if (field.type === "select") {
      validator = validator.required(
        field?.message || `Please select a ${field.label?.toLowerCase()}`
      );
    }
    if (field.textpart) {
      validator = validator.required(field?.message);
    }
    if (field.validation?.number) {
      validator = validator.matches(/^\+?[0-9]+$/, "Only numbers are allowed");
    }

    if (field.validation?.email) {
      validator = validator.email(field?.message || "Invalid email address");
    }

    if (field.validation?.minLength) {
      validator = validator.min(
        field.validation.minLength,
        `${field.label} must be at least ${field.validation.minLength} characters`
      );
    }

    if (field.validation?.type) {
      validator = validator.min(
        field.validation.minLength,
        `${field.label} must be at least ${field.validation.minLength} characters`
      );
    }
    if (field.validation?.type === "captcha") {
      validator = validator.required(
        field?.message || "Please verify the captcha"
      );
    }

    validationShape[field.name] = validator;
  });
  return Yup.object().shape(validationShape);
};
